import React from 'react';
import { motion } from 'framer-motion';
import { Car, Truck, Heart, Home, Bike, Shield } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function PracticeAreas() {
  const {
    t
  } = useLanguage();
  const practices = [{
    num: '01',
    icon: Car,
    title: t('practice.1.title'),
    desc: t('practice.1.desc')
  }, {
    num: '02',
    icon: Truck,
    title: t('practice.2.title'),
    desc: t('practice.2.desc')
  }, {
    num: '03',
    icon: Heart,
    title: t('practice.3.title'),
    desc: t('practice.3.desc')
  }, {
    num: '04',
    icon: Home,
    title: t('practice.4.title'),
    desc: t('practice.4.desc')
  }, {
    num: '05',
    icon: Bike,
    title: t('practice.5.title'),
    desc: t('practice.5.desc')
  }, {
    num: '06',
    icon: Shield,
    title: t('practice.6.title'),
    desc: t('practice.6.desc')
  }];
  return <section id="practice" className="py-24 lg:py-[160px] px-8 lg:px-[60px] bg-[#000000] border-t border-white/[0.02]" data-id="element-219">
      <div className="max-w-[1400px] mx-auto" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20 lg:mb-24" data-id="element-221">
          <p className="font-sans text-[10px] tracking-[6px] uppercase text-crimson-glow font-medium mb-6 flex items-center justify-center gap-4 opacity-90" data-id="element-222">
            {t('practice.label')}
          </p>
          <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[64px] font-medium leading-[1.05] tracking-[-0.02em] text-white" data-id="element-223">
            {t('practice.headline')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1" data-id="element-224">
          {practices.map((practice, i) => {
          const Icon = practice.icon;
          return <motion.div key={practice.num} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 1.2,
            ease: [0.16, 1, 0.3, 1],
            delay: i % 3 * 0.15
          }} className="relative p-10 lg:p-[60px_48px] bg-[#050505] border border-white/[0.02] cursor-pointer overflow-hidden transition-all duration-500 group practice-card-hover hover:border-white/[0.05]" data-id="element-225">
                <span className="absolute top-8 right-10 font-serif text-[64px] font-light text-white/[0.02] leading-none transition-colors duration-500 z-10 group-hover:text-crimson/10" data-id="element-226">
                  {practice.num}
                </span>

                <div className="w-10 h-10 mb-8 relative z-20 text-white/20 transition-all duration-500 group-hover:text-crimson-glow group-hover:-translate-y-1" data-id="element-227">
                  <Icon strokeWidth={1.2} className="w-full h-full" data-id="element-228" />
                </div>

                <h3 className="font-serif text-[26px] font-medium text-white/90 mb-4 relative z-20 transition-colors duration-500 group-hover:text-white" data-id="element-229">
                  {practice.title}
                </h3>

                <p className="font-sans text-[14px] leading-[1.9] text-white/40 relative z-20 font-light transition-colors duration-500 group-hover:text-white/60" data-id="element-230">
                  {practice.desc}
                </p>

                <div className="mt-10 font-sans text-[10px] tracking-[4px] uppercase text-crimson opacity-0 -translate-x-4 transition-all duration-500 relative z-20 group-hover:opacity-100 group-hover:translate-x-0 flex items-center gap-2" data-id="element-231">
                  {t('practice.learnMore')}
                  <span className="text-[14px] leading-none mb-[2px]" data-id="element-232">→</span>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}